export function convertJSDateString(dateValue: string | null | undefined): string | null
{
    if(!dateValue)
        return null;

    var dt: string = new Date(dateValue).toDateString();
    var day: string = dt.split(" ")[2];
    return `${new Date(dateValue).getFullYear()}-${pad(new Date(dateValue).getMonth() + 1, 2)}-${day}T00:00:00.000Z`;
}

function pad(num: any, size: any) {
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}